/* eslint-disable no-param-reassign */
import Fetch, { V1 } from 'Util/fetcher';

const ON_REQUEST_NEWS_STOCK = 'ON_REQUEST_NEWS_STOCK';
const ON_REQUEST_NEWS_STOCK_FAILURE = 'ON_REQUEST_NEWS_STOCK_FAILURE';
const ON_REQUEST_NEWS_STOCK_SUCCESS = 'ON_REQUEST_NEWS_STOCK_SUCCESS';

function onRequestNewsStock(resetData) {
  return {
    type: ON_REQUEST_NEWS_STOCK,
    meta: { resetData },
  };
}

function onRequestNewsStockSuccess(payload) {
  return {
    type: ON_REQUEST_NEWS_STOCK_SUCCESS,
    payload,
  };
}

function onRequestNewsStockFailure(payload) {
  return {
    type: ON_REQUEST_NEWS_STOCK_FAILURE,
    payload,
  };
}

export const onDoRequestNewsStock = (payload, resetData = false) =>
  (dispatch) => {
    dispatch(onRequestNewsStock(resetData));
    Fetch.get(`${V1}news/feed/${payload}`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onRequestNewsStockSuccess(resp.json));
        } else {
          dispatch(onRequestNewsStockFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onRequestNewsStockFailure(error.message));
      });
  };

const INITIAL_STATE = {
  newsLoading: false,
  newsData: null,
  newsError: null,
};

const news = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case ON_REQUEST_NEWS_STOCK:
      if (action.meta.resetData) {
        return {
          ...state,
          newsLoading: true,
          newsData: null,
          newsError: null,
        };
      } 
        return {
          ...state,
          newsLoading: true,
          newsError: null,
        };
      
    case ON_REQUEST_NEWS_STOCK_SUCCESS:
      if (state.newsData) {
        const oldResults = [...state.newsData.results];
        state.newsData = {
          ...action.payload,
          results: [...oldResults, ...action.payload.results],
        };
      } else {
        state.newsData = action.payload;
      }
      return {
        ...state,
        newsLoading: false,
        newsError: null,
      };
    case ON_REQUEST_NEWS_STOCK_FAILURE:
      return {
        ...state,
        newsLoading: false,
        newsError: action.payload,
      };
    default:
      return state;
  }
};

export default news;
